// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3BoHs","title":"FrontImage_title__2Khm_"};